import type { SVGComponentProps } from 'BreetHelpers';

export const CashIcon = ({ ...rest }: SVGComponentProps) => (
	<svg
		width='103'
		height='72'
		viewBox='0 0 103 72'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<path
			d='M23.0968 51.8197L23.0008 68.5915C22.8154 68.5713 22.6554 68.5203 22.5379 68.4403L4.90614 56.3425C4.83878 56.2955 4.80626 56.2383 4.80469 56.1759L4.84824 48.5697L9.07465 48.458L15.0062 53.5788L23.0968 51.8197Z'
			fill='#306F11'
		/>
		<path
			d='M5.5616 51.6696L5.53907 55.6033C5.53805 55.7809 5.62906 55.9442 5.79099 56.0553L18.7034 64.915C18.819 64.9943 18.9902 64.8505 18.8816 64.7652C13.4328 60.4857 7.49957 55.5334 5.87878 51.6077C5.82262 51.4716 5.56244 51.5224 5.5616 51.6696Z'
			fill='#4C8322'
		/>
		<path
			d='M84.3502 51.5986L84.3444 51.5959C84.3839 51.773 84.1915 51.9821 83.8296 52.0813L23.7767 68.5176C23.6199 68.5609 23.4633 68.5859 23.3125 68.5952L23.409 51.7486L63.7982 42.9685C64.1677 42.8886 64.5444 42.9057 64.7989 43.0171L73.5437 46.7993L84.3937 43.9969L84.3502 51.5986Z'
			fill='#679733'
		/>
		<path
			d='M25.2369 61.8723L25.209 66.7388C25.2082 66.8826 25.3793 66.9755 25.5561 66.9271L82.6354 51.3048C82.7735 51.267 82.8705 51.162 82.8711 51.0497C82.872 50.8883 82.6787 50.7848 82.4808 50.8403C59.5023 57.2815 37.9637 62.7016 25.6504 61.5794C25.4377 61.56 25.2378 61.7007 25.2369 61.8723Z'
			fill='#83AB44'
		/>
		<path
			d='M64.8417 35.4071L84.1742 43.771C84.5687 43.9417 84.4039 44.3264 83.8726 44.4718L23.8189 60.9075C23.3314 61.041 22.8451 61.0098 22.5807 60.8284L4.94978 48.7293C4.66558 48.5343 5.00714 48.1493 5.57208 48.0265L63.8401 35.3593C64.2102 35.2789 64.5868 35.2968 64.8417 35.4071Z'
			fill='#BAD366'
		/>
		<path
			d='M84.1742 43.7703L81.9356 42.8018C59.2921 49.5072 22.6762 56.0863 21.363 44.5929L5.57208 48.0258C5.00714 48.1486 4.66557 48.5335 4.94979 48.7286L22.5808 60.8277C22.8451 61.0091 23.3314 61.0402 23.8189 60.9068L83.8726 44.4711C84.4039 44.3257 84.5688 43.9409 84.1742 43.7703Z'
			fill='#9EBF55'
		/>
		<path
			d='M80.8963 44.2709L24.291 59.7131C24.085 59.7704 23.8789 59.7567 23.7674 59.6804L7.84248 48.8492C7.65191 48.7185 7.87723 48.4591 8.25658 48.3764L21.5497 45.4792L63.5547 36.323C63.7098 36.2888 63.8714 36.2961 63.9788 36.3433L80.0616 43.3477L81.1045 43.8024C81.3651 43.917 81.251 44.1743 80.8963 44.2709Z'
			fill='#4C8322'
		/>
		<path
			d='M80.8963 44.2719L24.291 59.714C24.085 59.7714 23.8789 59.7576 23.7674 59.6814L7.84248 48.8501C7.65191 48.7194 7.87723 48.4601 8.25658 48.3773L21.5497 45.4802C24.6624 55.4077 57.9907 49.6625 80.0616 43.3486L81.1045 43.8033C81.3651 43.918 81.251 44.1753 80.8963 44.2719Z'
			fill='#4C8322'
		/>
		<path
			d='M76.2652 42.739C74.9292 43.214 74.3501 44.1238 74.8654 44.7683C74.9461 44.8698 75.0544 44.9654 75.1908 45.0509C75.2963 45.1186 75.232 45.2389 75.0582 45.2851L29.6261 57.6578C29.4194 57.7134 29.2186 57.6987 29.0954 57.6291C27.5189 56.7068 24.8851 56.5467 22.2093 57.2009C22.0013 57.2519 21.7961 57.2407 21.6855 57.1651L11.7537 50.4447C11.6593 50.3798 11.7553 50.2566 11.936 50.2045C13.6478 49.7038 14.6214 48.5509 13.9365 47.8582C13.8627 47.7853 13.9744 47.6674 14.1556 47.6266L21.7363 45.9717L59.5568 37.7141C59.7175 37.6788 59.8752 37.6875 59.9899 37.7329C61.4745 38.3276 63.5845 38.4313 65.687 38.0135C65.8494 37.9805 66.0108 37.9877 66.1222 38.0362L76.35 42.5091C76.4756 42.5632 76.4267 42.6827 76.2652 42.739Z'
			fill='#BAD366'
		/>
		<path
			d='M75.0577 45.2874L29.6255 57.6596C29.42 57.7155 29.2186 57.7015 29.0962 57.6311C27.5186 56.7093 24.8848 56.5485 22.2083 57.2034C22.0012 57.2539 21.7974 57.2427 21.686 57.1673L11.754 50.4467C11.6589 50.3825 11.7555 50.2592 11.9369 50.2064C13.6478 49.7065 14.6222 48.5535 13.9371 47.8599C13.8636 47.7874 13.9735 47.6693 14.1558 47.6294L21.7356 45.9746C25.5155 54.452 53.5023 50.3369 74.8644 44.7705C74.9449 44.8728 75.054 44.9673 75.1897 45.0531C75.2969 45.1205 75.232 45.2409 75.0577 45.2874Z'
			fill='#9EBF55'
		/>
		<path
			d='M67.4074 43.2084C66.0116 43.9366 63.5356 44.0107 61.897 43.3725C60.2718 42.7397 60.0991 41.6462 61.4944 40.9327C62.8823 40.2231 65.3138 40.1501 66.9394 40.7685C68.5784 41.392 68.7957 42.4842 67.4074 43.2084Z'
			fill='#83AB44'
		/>
		<path
			d='M29.9191 52.2704C28.3792 53.0431 25.8529 53.1153 24.2964 52.4294C22.752 51.7488 22.7594 50.5808 24.2945 49.8235C24.7602 49.5935 25.3152 49.4281 25.9044 49.3263C27.2451 49.0947 28.774 49.2012 29.85 49.6634C30.3623 49.8834 30.7111 50.1569 30.8921 50.4531C31.2672 51.057 30.9455 51.7547 29.9191 52.2704Z'
			fill='#83AB44'
		/>
		<path
			d='M55.1059 48.9983C55.9378 48.3549 56.4297 47.6389 56.5516 46.8879C56.7947 45.3948 55.5399 43.9966 53.1315 43.0435C49.0084 41.412 42.6473 41.6176 38.8393 43.5004C37.2692 44.2776 36.2963 45.2388 36.0374 46.283C35.6617 47.777 36.7965 49.2127 39.1686 50.2145C39.5669 50.3827 39.9888 50.5339 40.4292 50.6658C42.2914 51.2272 44.4799 51.4708 46.6465 51.4046C49.3328 51.323 51.9665 50.7662 53.8994 49.76C54.3569 49.5212 54.7628 49.2661 55.1059 48.9983ZM53.459 49.4731C50.5476 50.9863 45.8892 51.3754 42.1217 50.5666C41.2704 50.3843 40.465 50.1404 39.7404 49.8353C37.524 48.9022 36.4569 47.5792 36.7954 46.2125C37.0207 45.2956 37.8703 44.4518 39.2457 43.7703C42.7626 42.0282 48.708 41.8621 52.5926 43.4038C54.8431 44.297 56.0142 45.5907 55.7863 46.9582C55.6545 47.7679 55.0288 48.5311 53.9717 49.183C53.81 49.282 53.6391 49.3794 53.459 49.4731Z'
			fill='#83AB44'
		/>
		<path
			d='M52.3711 49.0845C51.9792 49.285 51.5472 49.4614 51.0861 49.6121C49.4841 50.139 47.5207 50.364 45.5942 50.2762C43.8783 50.199 42.1986 49.8743 40.83 49.301C37.5232 47.9156 37.3075 45.6055 40.2792 44.1432C43.2172 42.696 48.2356 42.5973 51.5506 43.9192C54.9164 45.2615 55.3181 47.5744 52.3711 49.0845Z'
			fill='#83AB44'
		/>
		<path
			d='M51.0876 49.6064C49.4856 50.1334 47.5222 50.3584 45.5957 50.2705C47.3847 50.0925 49.2218 49.8695 51.0876 49.6064Z'
			fill='#679733'
		/>
		<path
			d='M29.9191 52.2615C28.3792 53.0342 25.8529 53.1064 24.2964 52.4205C22.752 51.7399 22.7594 50.5719 24.2945 49.8146C24.7602 49.5846 25.3152 49.4193 25.9044 49.3174C27.3041 49.8407 28.984 50.2108 30.8921 50.4442C31.2672 51.0481 30.9455 51.7458 29.9191 52.2615Z'
			fill='#679733'
		/>
		<path
			d='M53.8999 49.7588C51.9671 50.765 49.3333 51.3218 46.647 51.4034C44.4804 51.4696 42.2919 51.2259 40.4297 50.6646C40.9849 50.6375 41.5498 50.604 42.1222 50.5653C45.8897 51.3742 50.5481 50.9851 53.4595 49.4719C53.6396 49.3781 53.8105 49.2808 53.9722 49.1818C54.3467 49.1214 54.7284 49.0599 55.1064 48.9971C54.7633 49.2648 54.3575 49.52 53.8999 49.7588Z'
			fill='#679733'
		/>
		<path
			d='M64.7858 49.6949L50.6078 53.575L44.058 50.42L28.668 43.0047L30.4703 42.6134L41.7054 40.1705L43.4744 39.7861L61.0021 47.9359L64.7858 49.6949Z'
			fill='#BF7D5A'
		/>
		<path
			d='M64.7864 49.6936L50.6084 53.5737L44.0586 50.4187C49.4065 49.9563 55.2194 49.0662 61.0027 47.9346L64.7864 49.6936Z'
			fill='#AA6256'
		/>
		<path
			d='M63.0722 50.163L52.3661 53.0928L46.3238 50.2005L30.4707 42.6118L41.7057 40.1689L59.087 48.299L63.0722 50.163Z'
			fill='#FFDE9B'
		/>
		<path
			d='M63.0708 50.1651L52.3665 53.0955L46.3242 50.2033C50.4284 49.7701 54.7523 49.1094 59.0875 48.3018L63.0708 50.1651Z'
			fill='#FFD475'
		/>
		<path
			d='M23.8188 60.904L23.7752 68.5148C23.2875 68.6475 22.8008 68.6169 22.5371 68.4345L22.5807 60.8252C22.8444 61.0076 23.3311 61.0382 23.8188 60.904Z'
			fill='#4C8322'
		/>
		<path
			d='M64.7877 49.6924L64.7441 57.3017L63.0275 57.7713L52.3236 60.7004L50.5664 61.1821L50.61 53.5729L52.3672 53.0927L63.0711 50.162L64.7877 49.6924Z'
			fill='#8A4852'
		/>
		<path
			d='M63.0697 50.1611L63.0262 57.7704L52.3223 60.6996L52.3658 53.0918L63.0697 50.1611Z'
			fill='#FFB961'
		/>
		<path
			d='M26.9543 42.2728L26.8582 59.0447C26.6729 59.0244 26.5128 58.9734 26.3954 58.8934L8.76356 46.7956C8.6962 46.7486 8.66369 46.6914 8.66211 46.629L8.70566 39.0228L12.9321 38.9111L18.8636 44.0319L26.9543 42.2728Z'
			fill='#306F11'
		/>
		<path
			d='M88.2076 42.0517L88.2018 42.049C88.2414 42.2262 88.0489 42.4352 87.687 42.5345L27.6341 58.9708C27.4773 59.014 27.3207 59.039 27.1699 59.0483L27.2664 42.2017L67.6557 33.4216C68.0252 33.3417 68.4019 33.3588 68.6563 33.4702L77.4011 37.2524L88.2511 34.45L88.2076 42.0517Z'
			fill='#679733'
		/>
		<path
			d='M29.0943 52.3255L29.0664 57.1919C29.0656 57.3357 29.2368 57.4286 29.4135 57.3803L86.4928 41.7579C86.6309 41.7201 86.7279 41.6151 86.7285 41.5028C86.7295 41.3414 86.5361 41.238 86.3382 41.2934C63.3597 47.7347 41.8211 53.1547 29.5078 52.0325C29.2951 52.0132 29.0953 52.1539 29.0943 52.3255Z'
			fill='#83AB44'
		/>
		<path
			d='M68.6991 25.8602L88.0317 34.2241C88.4262 34.3948 88.2613 34.7796 87.73 34.925L27.6763 51.3606C27.1888 51.4941 26.7026 51.463 26.4382 51.2815L8.80721 39.1824C8.523 38.9874 8.86456 38.6025 9.4295 38.4797L67.6975 25.8125C68.0676 25.732 68.4442 25.7499 68.6991 25.8602Z'
			fill='#BAD366'
		/>
		<path
			d='M88.0317 34.2234L85.793 33.2549C63.1496 39.9603 26.5337 46.5394 25.2204 35.046L9.4295 38.4789C8.86457 38.6017 8.52299 38.9867 8.80721 39.1817L26.4382 51.2808C26.7026 51.4622 27.1888 51.4933 27.6763 51.3599L87.73 34.9242C88.2613 34.7788 88.4262 34.3941 88.0317 34.2234Z'
			fill='#9EBF55'
		/>
		<path
			d='M84.7537 34.7241L28.1484 50.1662C27.9424 50.2235 27.7364 50.2098 27.6248 50.1336L11.6999 39.3023C11.5093 39.1716 11.7346 38.9123 12.114 38.8295L25.4072 35.9324L67.4122 26.7761C67.5672 26.7419 67.7288 26.7492 67.8362 26.7964L83.9191 33.8008L84.9619 34.2555C85.2225 34.3701 85.1084 34.6275 84.7537 34.7241Z'
			fill='#4C8322'
		/>
		<path
			d='M84.7537 34.725L28.1484 50.1671C27.9424 50.2245 27.7364 50.2107 27.6248 50.1345L11.6999 39.3032C11.5093 39.1725 11.7346 38.9132 12.114 38.8304L25.4072 35.9333C28.5198 45.8609 61.8481 40.1156 83.9191 33.8018L84.9619 34.2565C85.2225 34.3711 85.1084 34.6284 84.7537 34.725Z'
			fill='#4C8322'
		/>
		<path
			d='M80.1226 33.1922C78.7866 33.6672 78.2075 34.577 78.7228 35.2214C78.8035 35.3229 78.9118 35.4185 79.0482 35.504C79.1537 35.5717 79.0894 35.6921 78.9157 35.7382L33.4835 48.1109C33.2769 48.1665 33.076 48.1519 32.9529 48.0823C31.3764 47.1599 28.7426 46.9998 26.0668 47.654C25.8588 47.705 25.6535 47.6938 25.543 47.6182L15.6111 40.8979C15.5167 40.8329 15.6128 40.7098 15.7934 40.6576C17.5052 40.1569 18.4788 39.0041 17.7939 38.3113C17.7202 38.2384 17.8318 38.1205 18.013 38.0797L25.5937 36.4248L63.4142 28.1672C63.5749 28.132 63.7326 28.1406 63.8473 28.186C65.3319 28.7807 67.4419 28.8844 69.5444 28.4666C69.7068 28.4336 69.8682 28.4408 69.9796 28.4894L80.2074 32.9622C80.333 33.0163 80.2841 33.1358 80.1226 33.1922Z'
			fill='#BAD366'
		/>
		<path
			d='M78.9151 35.7405L33.4829 48.1128C33.2775 48.1686 33.076 48.1546 32.9536 48.0842C31.376 47.1624 28.7422 47.0016 26.0657 47.6565C25.8586 47.707 25.6548 47.6958 25.5435 47.6205L15.6114 40.8999C15.5164 40.8356 15.6129 40.7123 15.7943 40.6595C17.5052 40.1596 18.4796 39.0066 17.7945 38.313C17.721 38.2406 17.831 38.1224 18.0132 38.0825L25.5931 36.4277C29.373 44.9051 57.3597 40.79 78.7218 35.2236C78.8024 35.326 78.9115 35.4204 79.0472 35.5062C79.1543 35.5736 79.0895 35.694 78.9151 35.7405Z'
			fill='#9EBF55'
		/>
		<path
			d='M71.2648 33.6616C69.869 34.3897 67.393 34.4638 65.7544 33.8257C64.1292 33.1928 63.9565 32.0993 65.3518 31.3858C66.7397 30.6762 69.1712 30.6033 70.7968 31.2216C72.4359 31.8451 72.6531 32.9374 71.2648 33.6616Z'
			fill='#83AB44'
		/>
		<path
			d='M33.7765 42.7236C32.2366 43.4962 29.7103 43.5684 28.1538 42.8825C26.6094 42.202 26.6168 41.034 28.1519 40.2766C28.6176 40.0466 29.1726 39.8813 29.7618 39.7794C31.1025 39.5479 32.6314 39.6543 33.7074 40.1165C34.2197 40.3366 34.5686 40.61 34.7495 40.9062C35.1246 41.5102 34.8029 42.2079 33.7765 42.7236Z'
			fill='#83AB44'
		/>
		<path
			d='M58.9633 39.4514C59.7952 38.808 60.2872 38.092 60.409 37.341C60.6522 35.848 59.3973 34.4497 56.9889 33.4967C52.8658 31.8651 46.5047 32.0707 42.6967 33.9536C41.1267 34.7307 40.1538 35.6919 39.8949 36.7361C39.5191 38.2301 40.6539 39.6658 43.0261 40.6676C43.4243 40.8358 43.8463 40.987 44.2866 41.119C46.1488 41.6803 48.3373 41.9239 50.5039 41.8577C53.1902 41.7761 55.824 41.2194 57.7568 40.2131C58.2144 39.9743 58.6202 39.7192 58.9633 39.4514ZM57.3164 39.9262C54.405 41.4395 49.7466 41.8285 45.9792 41.0197C45.1278 40.8374 44.3224 40.5935 43.5978 40.2885C41.3814 39.3553 40.3144 38.0323 40.6528 36.6657C40.8781 35.7487 41.7277 34.9049 43.1032 34.2234C46.62 32.4813 52.5655 32.3152 56.45 33.8569C58.7005 34.7501 59.8716 36.0438 59.6437 37.4114C59.5119 38.2211 58.8862 38.9842 57.8291 39.6361C57.6674 39.7351 57.4965 39.8325 57.3164 39.9262Z'
			fill='#83AB44'
		/>
		<path
			d='M56.2285 39.5376C55.8366 39.7381 55.4046 39.9145 54.9435 40.0652C53.3415 40.5921 51.3781 40.8171 49.4516 40.7293C47.7357 40.6521 46.056 40.3275 44.6874 39.7541C41.3806 38.3687 41.1649 36.0586 44.1366 34.5964C47.0747 33.1492 52.093 33.0504 55.408 34.3723C58.7738 35.7146 59.1755 38.0276 56.2285 39.5376Z'
			fill='#83AB44'
		/>
		<path
			d='M54.945 40.0596C53.343 40.5865 51.3796 40.8115 49.4531 40.7237C51.2421 40.5456 53.0792 40.3227 54.945 40.0596Z'
			fill='#679733'
		/>
		<path
			d='M33.7765 42.7147C32.2366 43.4873 29.7103 43.5595 28.1538 42.8736C26.6094 42.1931 26.6168 41.0251 28.1519 40.2677C28.6176 40.0377 29.1726 39.8724 29.7618 39.7705C31.1615 40.2938 32.8414 40.6639 34.7495 40.8973C35.1246 41.5013 34.8029 42.199 33.7765 42.7147Z'
			fill='#679733'
		/>
		<path
			d='M57.7573 40.2119C55.8245 41.2181 53.1907 41.7749 50.5044 41.8565C48.3378 41.9227 46.1494 41.6791 44.2871 41.1177C44.8424 41.0906 45.4072 41.0571 45.9797 41.0185C49.7471 41.8273 54.4055 41.4382 57.3169 39.925C57.497 39.8313 57.6679 39.7339 57.8296 39.6349C58.2041 39.5745 58.5858 39.5131 58.9638 39.4502C58.6207 39.718 58.2149 39.9731 57.7573 40.2119Z'
			fill='#679733'
		/>
		<path
			d='M68.6432 40.1481L54.4652 44.0282L47.9154 40.8731L32.5254 33.4578L34.3278 33.0665L45.5628 30.6236L47.3318 30.2393L64.8596 38.389L68.6432 40.1481Z'
			fill='#BF7D5A'
		/>
		<path
			d='M68.6438 40.1467L54.4658 44.0268L47.916 40.8718C53.2639 40.4094 59.0768 39.5193 64.8601 38.3877L68.6438 40.1467Z'
			fill='#AA6256'
		/>
		<path
			d='M66.9296 40.6162L56.2235 43.5459L50.1812 40.6537L34.3281 33.0649L45.5631 30.6221L62.9444 38.7521L66.9296 40.6162Z'
			fill='#FFDE9B'
		/>
		<path
			d='M66.9282 40.6182L56.2239 43.5487L50.1816 40.6564C54.2858 40.2232 58.6098 39.5625 62.9449 38.7549L66.9282 40.6182Z'
			fill='#FFD475'
		/>
		<path
			d='M27.6762 51.3571L27.6326 58.9679C27.1449 59.1006 26.6582 59.07 26.3945 58.8876L26.4381 51.2783C26.7018 51.4607 27.1885 51.4913 27.6762 51.3571Z'
			fill='#4C8322'
		/>
		<path
			d='M68.6451 40.1455L68.6015 47.7548L66.8849 48.2244L56.181 51.1536L54.4238 51.6352L54.4674 44.026L56.2246 43.5458L66.9285 40.6151L68.6451 40.1455Z'
			fill='#8A4852'
		/>
		<path
			d='M66.9272 40.6143L66.8836 48.2235L56.1797 51.1527L56.2233 43.5449L66.9272 40.6143Z'
			fill='#FFB961'
		/>
		<path
			d='M18.5709 36.0338L19.357 52.789C19.1704 52.7683 19.0074 52.7169 18.8857 52.6366L0.597711 40.5032C0.527808 40.4561 0.492247 40.3989 0.487386 40.3365L0.130859 32.7379L4.35613 32.6377L10.5637 37.7694L18.5709 36.0338Z'
			fill='#4C8322'
		/>
		<path
			d='M1.0099 35.8409L1.19428 39.7706C1.20261 39.9481 1.30231 40.1115 1.47026 40.2229L14.8633 49.1087C14.9831 49.1882 15.1469 49.045 15.0338 48.9595C9.35369 44.6695 3.15331 39.7061 1.32419 35.7798C1.26081 35.6438 1.003 35.6938 1.0099 35.8409Z'
			fill='#306F11'
		/>
		<path
			d='M79.8805 35.9801L79.8746 35.9775C79.9235 36.1545 79.7418 36.3629 79.3847 36.461L20.1292 52.7196C19.9745 52.7624 19.819 52.7869 19.6686 52.7958L18.8789 35.966L58.8516 27.3032C59.2173 27.2243 59.5953 27.2425 59.8559 27.3544L68.8095 31.1564L79.5242 28.386L79.8805 35.9801Z'
			fill='#679733'
		/>
		<path
			d='M21.2424 46.0899L21.4705 50.9515C21.4773 51.0952 21.6535 51.1885 21.8279 51.1407L78.1494 35.6873C78.2857 35.6499 78.3772 35.5453 78.372 35.433C78.3644 35.2718 78.1654 35.1679 77.9702 35.2228C55.3047 41.5959 34.0271 46.9526 21.641 45.7984C21.4271 45.7785 21.2344 45.9185 21.2424 46.0899Z'
			fill='#83AB44'
		/>
		<path
			d='M59.5007 19.7522L79.2949 28.16C79.6988 28.3316 79.554 28.7155 79.0298 28.8593L19.7733 45.1173C19.2923 45.2492 18.8039 45.2168 18.5296 45.0349L0.242432 32.9002C-0.0523521 32.7046 0.269339 32.3209 0.828458 32.1998L58.4955 19.7018C58.8617 19.6224 59.2397 19.6414 59.5007 19.7522Z'
			fill='#BAD366'
		/>
		<path
			d='M79.2949 28.1582L77.0028 27.1846C54.6867 33.8225 18.3758 40.2966 16.4565 28.8109L0.828454 32.1979C0.269346 32.3191 -0.0523591 32.7027 0.242437 32.8983L18.5296 45.033C18.8039 45.215 19.2923 45.2474 19.7733 45.1154L79.0298 28.8575C79.554 28.7136 79.6988 28.3297 79.2949 28.1582Z'
			fill='#9EBF55'
		/>
		<path
			d='M76.0387 28.6531L20.1823 43.9277C19.979 43.9844 19.772 43.9701 19.6564 43.8937L3.1438 33.0301C2.94614 32.8991 3.15807 32.6406 3.53349 32.5589L16.6892 29.7004L58.2596 20.6662C58.413 20.6325 58.5752 20.6402 58.6852 20.6876L75.1545 27.7284L76.2225 28.1855C76.4894 28.3007 76.3887 28.5575 76.0387 28.6531Z'
			fill='#679733'
		/>
		<path
			d='M76.0387 28.6482L20.1823 43.9229C19.979 43.9796 19.772 43.9653 19.6564 43.8889L3.1438 33.0253C2.94614 32.8942 3.15807 32.6358 3.53349 32.5541L16.6892 29.6956C20.3276 39.6218 53.3909 33.9719 75.1545 27.7236L76.2225 28.1807C76.4894 28.2959 76.3887 28.5527 76.0387 28.6482Z'
			fill='#4C8322'
		/>
		<path
			d='M71.3223 27.1067C70.0098 27.5776 69.4779 28.485 70.0277 29.1302C70.1138 29.2318 70.2272 29.3276 70.3683 29.4134C70.4775 29.4813 70.4195 29.6013 70.2479 29.647L25.4157 41.8853C25.2117 41.9402 25.0099 41.9251 24.883 41.8552C23.2562 40.9296 20.611 40.7625 17.9666 41.4089C17.7611 41.4593 17.555 41.4475 17.4403 41.3717L7.14381 34.6312C7.04592 34.566 7.13558 34.4433 7.31367 34.3916C9.00109 33.8961 9.91512 32.747 9.19299 32.053C9.11533 31.98 9.2209 31.8625 9.40017 31.8222L16.9023 30.1894L54.3308 22.0417C54.4898 22.0069 54.6481 22.0159 54.7654 22.0616C56.2829 22.6598 58.4008 22.769 60.4836 22.3573C60.6445 22.3247 60.8064 22.3324 60.9205 22.3812L71.3951 26.8772C71.5237 26.9316 71.481 27.0508 71.3223 27.1067Z'
			fill='#BAD366'
		/>
		<path
			d='M70.2473 29.6468L25.4151 41.8846C25.2123 41.9398 25.0099 41.9253 24.8836 41.8546C23.2558 40.9295 20.6106 40.7618 17.9655 41.4088C17.7609 41.4587 17.5563 41.447 17.4408 41.3714L7.14409 34.6307C7.04556 34.5662 7.13576 34.4433 7.31454 34.3911C9.00105 33.8962 9.91595 32.747 9.19361 32.0523C9.11621 31.9797 9.22004 31.8619 9.40041 31.8226L16.9017 30.1897C21.1318 38.6691 48.9334 34.6333 70.0266 29.1299C70.1127 29.2323 70.2269 29.327 70.3672 29.4131C70.478 29.4807 70.4195 29.6008 70.2473 29.6468Z'
			fill='#9EBF55'
		/>
		<path
			d='M62.4807 27.5497C61.1216 28.2734 58.6467 28.3408 56.9727 27.6988C55.3124 27.0622 55.0819 25.9693 56.4413 25.2603C57.7934 24.5551 60.2238 24.4888 61.8838 25.1109C63.5574 25.7382 63.8324 26.83 62.4807 27.5497Z'
			fill='#83AB44'
		/>
		<path
			d='M25.4259 36.501C23.925 37.2688 21.3996 37.3341 19.8053 36.6447C18.2234 35.9607 18.1693 34.7938 19.6663 34.0414C20.1204 33.8128 20.6674 33.6491 21.2519 33.549C22.5819 33.3213 24.1181 33.4317 25.2196 33.8963C25.7441 34.1176 26.1077 34.3917 26.3044 34.6881C26.7117 35.2925 26.4264 35.9886 25.4259 36.501Z'
			fill='#83AB44'
		/>
		<path
			d='M50.4683 33.3034C51.2673 32.6629 51.7222 31.9489 51.8047 31.1989C51.9696 29.7081 50.6397 28.3078 48.1785 27.3492C43.965 25.7081 37.6075 25.8964 33.8943 27.7672C32.3634 28.5393 31.44 29.497 31.2357 30.5394C30.9381 32.031 32.1497 33.4683 34.5772 34.4755C34.9848 34.6446 35.4152 34.7968 35.8629 34.9298C37.7568 35.4956 39.9605 35.7449 42.1261 35.6846C44.8111 35.6103 47.4185 35.0612 49.3006 34.0611C49.7461 33.8238 50.1389 33.57 50.4683 33.3034ZM48.8446 33.7733C46.0095 35.2773 41.3664 35.6534 37.5522 34.8352C36.6903 34.6508 35.8711 34.405 35.1297 34.0983C32.8617 33.1601 31.7239 31.8355 31.9908 30.4711C32.1681 29.5557 32.9743 28.715 34.3154 28.0379C37.7446 26.3069 43.6879 26.157 47.658 27.7077C49.958 28.606 51.1985 29.9016 51.0422 31.2672C50.9529 32.0758 50.3666 32.8365 49.3426 33.4849C49.186 33.5834 49.02 33.6802 48.8446 33.7733Z'
			fill='#83AB44'
		/>
		<path
			d='M47.7358 33.3845C47.3541 33.5837 46.9309 33.7587 46.4772 33.9081C44.9011 34.4301 42.9474 34.6496 41.0141 34.5567C39.2922 34.475 37.5935 34.1461 36.1933 33.5697C32.8099 32.1768 32.4724 29.8683 35.3705 28.4155C38.2357 26.9776 43.2545 26.8924 46.6427 28.222C50.0829 29.572 50.6067 31.8838 47.7358 33.3845Z'
			fill='#83AB44'
		/>
		<path
			d='M46.4787 33.9111C44.9027 34.4332 42.9489 34.6527 41.0156 34.5598C42.7973 34.3867 44.6247 34.1689 46.4787 33.9111Z'
			fill='#679733'
		/>
		<path
			d='M25.4259 36.5038C23.925 37.2716 21.3996 37.3369 19.8053 36.6475C18.2234 35.9635 18.1693 34.7966 19.6663 34.0441C20.1204 33.8156 20.6674 33.6519 21.2519 33.5518C22.6807 34.0783 24.3819 34.4526 26.3044 34.6909C26.7117 35.2953 26.4264 35.9914 25.4259 36.5038Z'
			fill='#679733'
		/>
		<path
			d='M49.3029 34.0673C47.4208 35.0673 44.8134 35.6165 42.1284 35.6908C39.9628 35.751 37.7591 35.5018 35.8652 34.936C36.4197 34.9103 36.9834 34.8784 37.5545 34.8414C41.3687 35.6596 46.0119 35.2834 48.8469 33.7795C49.0223 33.6863 49.1883 33.5895 49.3449 33.491C49.7167 33.4317 50.0956 33.3714 50.4707 33.3096C50.1413 33.5762 49.7484 33.8299 49.3029 34.0673Z'
			fill='#679733'
		/>
		<path
			d='M60.1978 34.0238L46.208 37.862L39.4849 34.6924L23.6875 27.2429L25.4713 26.8568L36.5904 24.4466L38.3412 24.0674L56.3173 32.2564L60.1978 34.0238Z'
			fill='#BF7D5A'
		/>
		<path
			d='M60.1973 34.0224L46.2075 37.8605L39.4844 34.6909C44.814 34.2434 50.5865 33.3698 56.3168 32.2549L60.1973 34.0224Z'
			fill='#AA6256'
		/>
		<path
			d='M58.506 34.492L47.942 37.39L41.7407 34.4844L25.4707 26.8604L36.5898 24.4502L54.4183 32.6191L58.506 34.492Z'
			fill='#FFDE9B'
		/>
		<path
			d='M58.5036 34.4943L47.9415 37.3931L41.7402 34.4874C45.8262 34.0656 50.1203 33.4173 54.4178 32.6221L58.5036 34.4943Z'
			fill='#FFD475'
		/>
		<path
			d='M19.7729 45.1182L20.1297 52.7214C19.6484 52.8526 19.1595 52.8208 18.886 52.6379L18.5293 45.0361C18.8029 45.219 19.2917 45.2509 19.7729 45.1182Z'
			fill='#4C8322'
		/>
		<path
			d='M60.1965 34.0283L60.5531 41.63L58.8593 42.0946L48.2975 44.992L46.5637 45.4685L46.207 37.8668L47.941 37.3919L58.5027 34.4929L60.1965 34.0283Z'
			fill='#8A4852'
		/>
		<path
			d='M58.5031 34.4893L58.8598 42.091L48.298 44.9884L47.9414 37.3882L58.5031 34.4893Z'
			fill='#FFB961'
		/>
		<path
			d='M22.06 26.6401L21.833 43.4106C21.6477 43.389 21.4881 43.3367 21.3713 43.2558L3.83452 31.0206C3.76753 30.9731 3.73546 30.9157 3.73438 30.8533L3.83735 23.2476L8.0645 23.1689L13.9559 28.3359L22.06 26.6401Z'
			fill='#306F11'
		/>
		<path
			d='M4.52791 26.3557L4.47466 30.2891C4.47225 30.4667 4.56198 30.6307 4.72303 30.7431L17.5659 39.7033C17.6808 39.7835 17.8531 39.6411 17.7453 39.555C12.33 35.233 6.43565 30.2345 4.84557 26.2963C4.79048 26.1598 4.5299 26.2085 4.52791 26.3557Z'
			fill='#4C8322'
		/>
		<path
			d='M83.3131 26.9038L83.3073 26.9011C83.3455 27.0785 83.1514 27.2861 82.7887 27.3825L22.6093 43.3492C22.4522 43.3912 22.2954 43.415 22.1445 43.4231L22.3726 26.5778L62.8292 18.1135C63.1993 18.0364 63.5759 18.0565 63.8294 18.1698L72.5444 22.0203L83.416 19.3027L83.3131 26.9038Z'
			fill='#679733'
		/>
		<path
			d='M24.1206 36.7209L24.0547 41.587C24.0528 41.7308 24.2232 41.825 24.4003 41.778L81.5999 26.602C81.7383 26.5653 81.8361 26.4611 81.8376 26.3487C81.8398 26.1874 81.6473 26.0824 81.449 26.1363C58.4208 32.3979 36.8405 37.6495 24.5364 36.4312C24.3238 36.4102 24.1229 36.5493 24.1206 36.7209Z'
			fill='#83AB44'
		/>
		<path
			d='M63.9328 10.5599L83.1994 19.0746C83.5926 19.2483 83.4248 19.6317 82.8923 19.773L22.7121 35.7391C22.2235 35.8687 21.7375 35.8338 21.4746 35.6503L3.93868 23.4138C3.656 23.2166 4.00056 22.8343 4.56645 22.7159L62.9316 10.5043C63.3023 10.4267 63.6788 10.4476 63.9328 10.5599Z'
			fill='#BAD366'
		/>
		<path
			d='M83.1994 19.0768L80.9684 18.0908C58.2733 24.6192 21.6071 30.9121 20.3837 19.4088L4.56644 22.7182C4.00056 22.8366 3.656 23.2188 3.93868 23.4161L21.4746 35.6525C21.7376 35.836 22.2235 35.8709 22.7121 35.7413L82.8923 19.7752C83.4248 19.634 83.5926 19.2505 83.1994 19.0768Z'
			fill='#9EBF55'
		/>
		<path
			d='M79.9172 19.5453L23.193 34.5448C22.9866 34.6005 22.7806 34.5852 22.6697 34.5081L6.82985 23.5527C6.64031 23.4206 6.86765 23.163 7.24764 23.0832L20.563 20.29L62.6383 11.4622C62.7936 11.4292 62.9551 11.4377 63.0622 11.4858L79.0898 18.6156L80.129 19.0784C80.3888 19.195 80.2727 19.4515 79.9172 19.5453Z'
			fill='#679733'
		/>
		<path
			d='M79.9172 19.544L23.193 34.5435C22.9866 34.5992 22.7806 34.5839 22.6697 34.5068L6.82985 23.5514C6.64031 23.4193 6.86765 23.1617 7.24764 23.0819L20.563 20.2887C23.598 30.2402 56.9701 24.7555 79.0898 18.6143L80.129 19.0771C80.3888 19.1937 80.2727 19.4502 79.9172 19.544Z'
			fill='#679733'
		/>
		<path
			d='M75.2995 17.9773C73.9598 18.4418 73.3736 19.3471 73.8839 19.9956C73.9638 20.0977 74.0713 20.1941 74.2071 20.2807C74.3121 20.3492 74.2468 20.469 74.0727 20.5138L28.5453 32.5313C28.3382 32.5852 28.1374 32.569 28.0149 32.4984C26.4456 31.5638 23.8132 31.3831 21.1323 32.0164C20.9239 32.0658 20.7187 32.053 20.6088 31.9765L10.7298 25.1788C10.6359 25.1131 10.7329 24.9907 10.9139 24.94C12.6296 24.4527 13.6122 23.3075 12.9327 22.6094C12.8595 22.5359 12.9721 22.4189 13.1536 22.3795L20.747 20.7839L58.6308 12.822C58.7918 12.788 58.9494 12.7978 59.0638 12.8442C60.5437 13.4505 62.6529 13.5706 64.7585 13.1692C64.9212 13.1375 65.0825 13.146 65.1935 13.1954L75.386 17.748C75.5113 17.8031 75.4614 17.9221 75.2995 17.9773Z'
			fill='#BAD366'
		/>
		<path
			d='M74.0721 20.5155L28.5447 32.5324C28.3388 32.5866 28.1374 32.5711 28.0156 32.4997C26.4453 31.5657 23.8128 31.3843 21.1312 32.0182C20.9238 32.0671 20.7201 32.0543 20.6093 31.9781L10.7301 25.1801C10.6355 25.1151 10.7331 24.9926 10.9148 24.9413C12.6296 24.4547 13.613 23.3094 12.9333 22.6104C12.8604 22.5374 12.9713 22.4201 13.1538 22.3817L20.7463 20.7861C24.4599 29.2928 52.4779 25.3964 73.8828 19.9971C73.9626 20.1 74.071 20.1953 74.206 20.2822C74.3126 20.3504 74.2468 20.4703 74.0721 20.5155Z'
			fill='#9EBF55'
		/>
		<path
			d='M66.4373 18.3806C65.0358 19.0978 62.5593 19.1526 60.9257 18.5017C59.3056 17.8561 59.1414 16.7613 60.5422 16.0588C61.9356 15.36 64.3676 15.306 65.9884 15.9371C67.6225 16.5734 67.8312 17.6673 66.4373 18.3806Z'
			fill='#83AB44'
		/>
		<path
			d='M28.879 27.1504C27.3331 27.911 24.8062 27.9634 23.2552 27.2654C21.7162 26.5728 21.7326 25.4049 23.2737 24.6595C23.7411 24.4332 24.2974 24.2722 24.8874 24.1749C26.2299 23.9539 27.7578 24.0722 28.8302 24.5428C29.3408 24.7669 29.6875 25.0431 29.8661 25.3407C30.2365 25.9475 29.9094 26.6427 28.879 27.1504Z'
			fill='#83AB44'
		/>
		<path
			d='M54.0905 24.0809C54.9274 23.444 55.4249 22.7318 55.5526 21.9818C55.8074 20.4907 54.5635 19.0827 52.1626 18.1109C48.0525 16.4471 41.6899 16.603 37.8674 18.4561C36.2913 19.221 35.3109 20.1745 35.0438 21.2167C34.6564 22.7077 35.78 24.1522 38.1442 25.1725C38.5412 25.3438 38.9619 25.4983 39.4012 25.6337C41.259 26.2096 43.4455 26.4703 45.6125 26.421C48.2994 26.3604 50.9374 25.8242 52.878 24.8331C53.3375 24.5979 53.7453 24.346 54.0905 24.0809ZM52.4399 24.5428C49.5168 26.0333 44.8555 26.3859 41.0945 25.5477C40.2446 25.3588 39.4411 25.1086 38.7189 24.7979C36.5099 23.8474 35.4532 22.5161 35.8023 21.1522C36.0348 20.237 36.891 19.3999 38.2717 18.7291C41.802 17.0145 47.7486 16.8949 51.621 18.4669C53.8645 19.3777 55.0254 20.6805 54.7868 22.0462C54.6487 22.8548 54.0171 23.6131 52.9548 24.2567C52.7924 24.3544 52.6208 24.4505 52.4399 24.5428Z'
			fill='#83AB44'
		/>
		<path
			d='M51.355 24.1414C50.9616 24.3388 50.5282 24.5118 50.0659 24.6589C48.4599 25.1733 46.4948 25.383 44.569 25.2801C42.8538 25.1895 41.1767 24.8518 39.8126 24.2678C36.5168 22.8566 36.3191 20.5448 39.3021 19.1059C42.2514 17.6816 47.2704 17.6221 50.5749 18.9699C53.9302 20.3384 54.3138 22.6544 51.355 24.1414Z'
			fill='#83AB44'
		/>
		<path
			d='M50.0672 24.6533C48.4612 25.1677 46.4961 25.3774 44.5703 25.2745C46.3606 25.1104 48.1994 24.9018 50.0672 24.6533Z'
			fill='#679733'
		/>
		<path
			d='M28.879 27.1444C27.3331 27.905 24.8062 27.9575 23.2552 27.2594C21.7162 26.5668 21.7326 25.3989 23.2737 24.6536C23.7411 24.4272 24.2974 24.2662 24.8874 24.1689C26.283 24.7031 27.9599 25.0864 29.8661 25.3347C30.2365 25.9415 29.9094 26.6367 28.879 27.1444Z'
			fill='#679733'
		/>
		<path
			d='M52.8792 24.8275C50.9386 25.8186 48.3005 26.3547 45.6137 26.4154C43.4466 26.4646 41.2602 26.2039 39.4023 25.628C39.9578 25.6052 40.5229 25.5761 41.0956 25.542C44.8566 26.3803 49.5179 26.0276 52.4411 24.5371C52.6219 24.4448 52.7936 24.3488 52.956 24.251C53.331 24.1936 53.7132 24.1351 54.0916 24.0752C53.7464 24.3403 53.3386 24.5922 52.8792 24.8275Z'
			fill='#679733'
		/>
		<path
			d='M63.7656 24.8455L49.5578 28.6147L43.0328 25.4086L27.7012 17.8733L29.5065 17.4961L40.7603 15.141L42.5323 14.7705L59.9958 23.057L63.7656 24.8455Z'
			fill='#BF7D5A'
		/>
		<path
			d='M63.766 24.8481L49.5581 28.6173L43.0332 25.4112C48.3846 24.9906 54.2042 24.1459 59.9962 23.0596L63.766 24.8481Z'
			fill='#AA6256'
		/>
		<path
			d='M62.0474 25.3062L51.3187 28.1522L45.2991 25.2129L29.5059 17.5005L40.7596 15.1455L58.0769 23.4111L62.0474 25.3062Z'
			fill='#FFDE9B'
		/>
		<path
			d='M62.0471 25.3055L51.3203 28.1523L45.3008 25.2129C49.4082 24.8118 53.7372 24.1849 58.0785 23.4111L62.0471 25.3055Z'
			fill='#FFD475'
		/>
		<path
			d='M22.7116 35.7418L22.6085 43.352C22.1198 43.4809 21.6333 43.4465 21.3711 43.262L21.4741 35.6533C21.7363 35.8378 22.2228 35.8721 22.7116 35.7418Z'
			fill='#4C8322'
		/>
		<path
			d='M63.7656 24.8486L63.6626 32.4573L61.9425 32.9135L51.216 35.759L49.4551 36.2269L49.5581 28.6182L51.319 28.1518L62.0455 25.3048L63.7656 24.8486Z'
			fill='#8A4852'
		/>
		<path
			d='M62.0443 25.3018L61.9413 32.9105L51.2148 35.7559L51.3178 28.1487L62.0443 25.3018Z'
			fill='#FFB961'
		/>
		<path
			d='M27.7104 16.493L27.4833 33.261C27.2981 33.2373 27.1384 33.1832 27.0217 33.1009L9.48491 20.6683C9.41792 20.62 9.38586 20.5622 9.38477 20.4998L9.48774 12.8953L13.7149 12.8643L19.6063 18.0975L27.7104 16.493Z'
			fill='#306F11'
		/>
		<path
			d='M10.1783 16.0099L10.125 19.9427C10.1226 20.1203 10.2124 20.2853 10.3734 20.3995L23.2163 29.5044C23.3312 29.5859 23.5035 29.4454 23.3956 29.3581C17.9804 24.9751 12.086 19.9103 10.496 15.9541C10.4409 15.817 10.1803 15.8628 10.1783 16.0099Z'
			fill='#4C8322'
		/>
		<path
			d='M88.9635 17.4422L88.9577 17.4394C88.9959 17.6173 88.8018 17.8226 88.4391 17.9149L28.2597 33.2039C28.1026 33.2442 27.9458 33.2662 27.7949 33.2726L28.023 16.4299L68.4796 8.42115C68.8497 8.34827 69.2263 8.37259 69.4798 8.4888L78.1948 12.4373L89.0664 9.84222L88.9635 17.4422Z'
			fill='#679733'
		/>
		<path
			d='M29.771 26.5897L29.7051 31.4551C29.7031 31.5989 29.8736 31.695 30.0507 31.65L87.2503 17.1182C87.3887 17.0831 87.4865 16.9799 87.488 16.8676C87.4902 16.7063 87.2976 16.5991 87.0993 16.6508C64.0712 22.653 42.4909 27.6616 30.1868 26.3047C29.9742 26.2813 29.7733 26.4182 29.771 26.5897Z'
			fill='#83AB44'
		/>
		<path
			d='M69.5832 0.878818L88.8498 9.61049C89.243 9.78867 89.0751 10.1702 88.5427 10.3055L28.3625 25.5938C27.8739 25.7179 27.3879 25.6775 27.125 25.4911L9.58907 13.0572C9.30639 12.8567 9.65095 12.4784 10.2168 12.3663L68.582 0.811963C68.9527 0.738577 69.3292 0.763694 69.5832 0.878818Z'
			fill='#BAD366'
		/>
		<path
			d='M88.8498 9.60973L86.6188 8.59863C63.9237 14.8714 27.2575 20.7514 26.0341 9.23429L10.2168 12.3656C9.65095 12.4776 9.30639 12.856 9.58907 13.0564L27.125 25.4903C27.3879 25.6768 27.8739 25.7172 28.3625 25.5931L88.5427 10.3047C89.0751 10.1694 89.243 9.7879 88.8498 9.60973Z'
			fill='#9EBF55'
		/>
		<path
			d='M85.5676 10.0504L28.8434 24.411C28.6369 24.4645 28.431 24.4468 28.3201 24.3684L12.4802 13.2347C12.2907 13.1004 12.518 12.8454 12.898 12.7699L26.2134 10.1266L68.2886 1.77263C68.444 1.74139 68.6055 1.75173 68.7125 1.801L84.7401 9.11128L85.7794 9.58583C86.0391 9.7054 85.923 9.96054 85.5676 10.0504Z'
			fill='#679733'
		/>
		<path
			d='M85.5676 10.0455L28.8434 24.4062C28.6369 24.4596 28.431 24.4419 28.3201 24.3636L12.4802 13.2299C12.2907 13.0956 12.518 12.8405 12.898 12.765L26.2134 10.1218C29.2484 20.1075 62.6205 14.9986 84.7401 9.10645L85.7794 9.581C86.0391 9.70056 85.923 9.9557 85.5676 10.0455Z'
			fill='#4C8322'
		/>
		<path
			d='M80.9499 8.42854C79.6102 8.878 79.024 9.77665 79.5343 10.4309C79.6142 10.5339 79.7217 10.6315 79.8575 10.7196C79.9624 10.7894 79.8972 10.9084 79.7231 10.9513L34.1957 22.456C33.9886 22.5076 33.7878 22.4892 33.6653 22.4172C32.096 21.4649 29.4635 21.2546 26.7827 21.8577C26.5743 21.9047 26.3691 21.8896 26.2592 21.8119L16.3801 14.9029C16.2863 14.8362 16.3833 14.7149 16.5643 14.6661C18.28 14.1982 19.2626 13.064 18.5831 12.3583C18.5099 12.284 18.6225 12.1683 18.804 12.1309L26.3974 10.6208L64.2812 3.08553C64.4422 3.05333 64.5998 3.06497 64.7142 3.11259C66.1941 3.73554 68.3032 3.87945 70.4089 3.50179C70.5716 3.47186 70.7329 3.48218 70.8439 3.53284L81.0364 8.20023C81.1617 8.25675 81.1118 8.37523 80.9499 8.42854Z'
			fill='#BAD366'
		/>
		<path
			d='M79.7225 10.9473L34.1951 22.4515C33.9892 22.5034 33.7878 22.4856 33.666 22.4129C32.0957 21.4611 29.4632 21.2501 26.7816 21.8539C26.5742 21.9004 26.3705 21.8853 26.2597 21.8079L16.3805 14.8986C16.2859 14.8325 16.3834 14.7111 16.5652 14.6618C18.28 14.1946 19.2634 13.0603 18.5837 12.3537C18.5108 12.2799 18.6216 12.1638 18.8042 12.1275L26.3967 10.6174C30.1103 19.1659 58.1283 15.585 79.5332 10.4268C79.613 10.5306 79.7214 10.6271 79.8564 10.7155C79.963 10.7849 79.8972 10.9041 79.7225 10.9473Z'
			fill='#9EBF55'
		/>
		<path
			d='M72.0877 8.72816C70.6862 9.42958 68.2097 9.45646 66.5761 8.78714C64.956 8.12333 64.7918 7.0267 66.1926 6.33992C67.586 5.65682 70.018 5.63028 71.6388 6.2796C73.2729 6.93425 73.4816 8.03053 72.0877 8.72816Z'
			fill='#83AB44'
		/>
		<path
			d='M34.5293 17.0714C32.9835 17.8146 30.4566 17.8386 28.9056 17.1231C27.3666 16.4131 27.383 15.2454 28.924 14.5174C29.3915 14.2964 29.9478 14.1416 30.5378 14.051C31.8803 13.8451 33.4082 13.9806 34.4806 14.4633C34.9912 14.6931 35.3379 14.9732 35.5165 15.2728C35.8869 15.8838 35.5597 16.5753 34.5293 17.0714Z'
			fill='#83AB44'
		/>
		<path
			d='M59.7408 14.2889C60.5777 13.6614 61.0753 12.9549 61.203 12.2063C61.4578 10.7181 60.2139 9.29607 57.813 8.2972C53.7029 6.58717 47.3403 6.67142 43.5178 8.48145C41.9417 9.22856 40.9613 10.1711 40.6942 11.2102C40.3068 12.6969 41.4304 14.1541 43.7946 15.201C44.1915 15.3767 44.6123 15.536 45.0516 15.6763C46.9094 16.2731 49.0959 16.5584 51.2629 16.5336C53.9498 16.5032 56.5878 15.9968 58.5284 15.0275C58.9879 14.7975 59.3957 14.5501 59.7408 14.2889ZM58.0903 14.7322C55.1672 16.1898 50.5059 16.49 46.7449 15.6093C45.895 15.4109 45.0915 15.1516 44.3693 14.8328C42.1603 13.8575 41.1036 12.5142 41.4527 11.1542C41.6852 10.2417 42.5414 9.41422 43.9221 8.75901C47.4524 7.08416 53.399 7.03147 57.2714 8.64713C59.5148 9.58316 60.6758 10.899 60.4372 12.2621C60.2991 13.0692 59.6674 13.8203 58.6052 14.452C58.4428 14.5478 58.2711 14.6419 58.0903 14.7322Z'
			fill='#83AB44'
		/>
		<path
			d='M57.0074 14.3155C56.6139 14.5084 56.1806 14.6766 55.7183 14.8185C54.1122 15.3148 52.1471 15.5023 50.2214 15.3777C48.5061 15.2678 46.829 14.9112 45.465 14.3118C42.1691 12.8635 41.9715 10.5495 44.9545 9.14415C47.9037 7.75316 52.9227 7.75011 56.2273 9.13514C59.5825 10.5414 59.9661 12.8618 57.0074 14.3155Z'
			fill='#83AB44'
		/>
		<path
			d='M55.7176 14.8174C54.1116 15.3137 52.1465 15.5012 50.2207 15.3767C52.011 15.2327 53.8498 15.0448 55.7176 14.8174Z'
			fill='#679733'
		/>
		<path
			d='M34.5293 17.0721C32.9835 17.8153 30.4566 17.8394 28.9056 17.1238C27.3666 16.4139 27.383 15.2462 28.924 14.5182C29.3915 14.2971 29.9478 14.1424 30.5378 14.0518C31.9333 14.6017 33.6103 15.0038 35.5165 15.2736C35.8869 15.8846 35.5597 16.5761 34.5293 17.0721Z'
			fill='#679733'
		/>
		<path
			d='M58.5296 15.0247C56.589 15.994 53.9509 16.5004 51.2641 16.5308C49.097 16.5557 46.9106 16.2703 45.0527 15.6736C45.6082 15.657 46.1733 15.6343 46.746 15.6066C50.507 16.4872 55.1683 16.187 58.0915 14.7295C58.2723 14.6392 58.444 14.5451 58.6064 14.4492C58.9814 14.3959 59.3636 14.3418 59.742 14.2861C59.3968 14.5473 58.989 14.7947 58.5296 15.0247Z'
			fill='#679733'
		/>
		<path
			d='M69.416 15.1627L55.2081 18.772L48.6832 15.4924L33.3516 7.78441L35.1569 7.4275L46.4107 5.19921L48.1827 4.84863L65.6462 13.3317L69.416 15.1627Z'
			fill='#BF7D5A'
		/>
		<path
			d='M69.4164 15.164L55.2085 18.7732L48.6836 15.4936C54.0349 15.1333 59.8546 14.3542 65.6466 13.333L69.4164 15.164Z'
			fill='#AA6256'
		/>
		<path
			d='M67.6977 15.6006L56.9691 18.3258L50.9495 15.3187L35.1562 7.42849L46.41 5.2002L63.7273 13.6608L67.6977 15.6006Z'
			fill='#FFDE9B'
		/>
		<path
			d='M67.6975 15.6002L56.9707 18.3262L50.9512 15.319C55.0586 14.9641 59.3876 14.386 63.7289 13.6611L67.6975 15.6002Z'
			fill='#FFD475'
		/>
		<path
			d='M28.3619 25.5916L28.2589 33.2007C27.7702 33.3241 27.2837 33.2842 27.0215 33.0968L27.1245 25.4893C27.3867 25.6766 27.8732 25.7165 28.3619 25.5916Z'
			fill='#4C8322'
		/>
		<path
			d='M69.416 15.1611L69.313 22.7687L67.5928 23.2055L56.8664 25.9302L55.1055 26.3783L55.2085 18.7707L56.9694 18.3241L67.6958 15.598L69.416 15.1611Z'
			fill='#8A4852'
		/>
		<path
			d='M67.6947 15.5986L67.5917 23.2062L56.8652 25.9308L56.9682 18.3248L67.6947 15.5986Z'
			fill='#FFB961'
		/>
		<path
			d='M36.1257 41.0324L31.209 41.6155L34.7637 37.208L36.1257 41.0324Z'
			fill='#306F11'
		/>
		<path
			d='M102.5 46.5752L98.8077 51.1563L97.8613 47.8436L102.5 46.5752Z'
			fill='#679733'
		/>
		<path
			d='M72.8446 28.9033L39.3602 71.4942C39.2683 71.4183 39.1985 71.3104 39.1585 71.1706L30.8488 42.7947C30.699 42.2835 31.1244 41.4827 31.6257 41.3309L72.8446 28.9033Z'
			fill='#306F11'
		/>
		<path
			d='M98.1163 51.7043L40.0104 71.5709C39.8367 71.6308 39.6749 71.6348 39.5371 71.5909L73.1752 28.8023L90.4876 23.582C90.913 23.4522 91.2365 23.602 91.3483 23.9794L99.1208 50.1646C99.2666 50.6559 98.7134 51.4986 98.1163 51.7043Z'
			fill='#679733'
		/>
		<path
			d='M95.0709 19.346L102.843 45.5321C102.988 46.0223 102.436 46.8667 101.838 47.0711L43.732 66.938C43.3263 67.0767 42.9923 66.9197 42.8804 66.5376L34.5693 38.1598C34.4201 37.6502 34.8456 36.8482 35.347 36.6971L94.2097 18.9484C94.6351 18.8201 94.9592 18.9697 95.0709 19.346Z'
			fill='#BAD366'
		/>
		<path
			d='M102.843 45.5341L102.008 42.7217C77.2391 52.3895 45.0488 57.6455 49.8526 32.3252L35.347 36.699C34.8456 36.8502 34.4201 37.6522 34.5693 38.1618L42.8804 66.5396C42.9923 66.9216 43.3263 67.0787 43.732 66.94L101.838 47.0731C102.436 46.8687 102.988 46.0242 102.843 45.5341Z'
			fill='#9EBF55'
		/>
		<path
			d='M43.7334 66.9375L40.0109 71.5707C39.6056 71.7084 39.27 71.5527 39.1582 71.1692L42.8807 66.5361C42.9925 66.9195 43.326 67.0753 43.7334 66.9375Z'
			fill='#9EBF55'
		/>
		<path
			d='M99.5706 45.8927L44.5928 64.8653C44.4214 64.9233 44.2754 64.8583 44.2282 64.6942L36.8191 39.0964C36.7245 38.7587 37.0106 38.221 37.3493 38.1202L49.5163 34.4933L92.9152 21.5462C93.0935 21.4942 93.229 21.5575 93.2759 21.7135L99.8417 43.5467L100.238 44.8577C100.336 45.1864 99.97 45.7534 99.5706 45.8927Z'
			fill='#679733'
		/>
		<path
			d='M99.5712 45.8884L44.5934 64.8605C44.4193 64.9226 44.2766 64.854 44.2296 64.6905L36.8199 39.0948C36.7227 38.755 37.0103 38.2178 37.3478 38.1169L49.5147 34.4893C46.8527 56.7328 76.0888 52.4113 99.8433 43.5418L100.238 44.8561C100.335 45.185 99.9683 45.7518 99.5712 45.8884Z'
			fill='#4C8322'
		/>
		<path
			d='M93.7045 46.8054L49.443 62.1618C49.2645 62.2235 49.1233 62.154 49.0678 61.9944C48.3536 59.894 46.4773 59.0152 44.1951 59.703C44.0198 59.7556 43.8744 59.6903 43.8259 59.5217L39.2304 43.5413C39.1837 43.379 39.3127 43.1306 39.4779 43.0561C41.0454 42.3442 42.3481 39.9898 42.1255 38.253C42.1005 38.0698 42.2444 37.8241 42.4097 37.7749L49.3972 35.7037L87.9036 24.289C88.0806 24.2363 88.2138 24.2982 88.2701 24.4482C88.9929 26.4105 90.7507 27.226 93.0444 26.6591C93.2218 26.6141 93.3578 26.6734 93.4048 26.8308L97.5915 40.6517C97.6406 40.8128 97.477 41.084 97.2806 41.1794C95.6644 41.9801 94.2642 43.9695 94.0526 45.5802C94.0185 45.8339 94.0158 46.0759 94.0435 46.3042C94.0658 46.4833 93.8939 46.7415 93.7045 46.8054Z'
			fill='#BAD366'
		/>
		<path
			d='M93.7045 46.8018L49.443 62.1582C49.2645 62.22 49.1233 62.1505 49.0678 61.9909C48.3536 59.8905 46.4773 59.0117 44.1951 59.6994C44.0198 59.752 43.8744 59.6868 43.8259 59.5181L39.2304 43.5378C39.1837 43.3755 39.3127 43.1271 39.4779 43.0526C41.0454 42.3407 42.3481 39.9863 42.1255 38.2495C42.1005 38.0662 42.2444 37.8206 42.4097 37.7714L49.3972 35.7002C47.9617 55.0115 72.0438 52.8081 94.0526 45.5767C94.0185 45.8304 94.0158 46.0723 94.0435 46.3007C94.0658 46.4797 93.8939 46.738 93.7045 46.8018Z'
			fill='#9EBF55'
		/>
		<path
			d='M89.3381 40.1245C87.4809 41.5075 85.3447 41.0827 84.5519 39.1735C83.7558 37.2565 84.6082 34.5396 86.4724 33.1103C88.3535 31.668 90.5343 32.0932 91.3234 34.057C92.1091 36.0125 91.212 38.7291 89.3381 40.1245Z'
			fill='#83AB44'
		/>
		<path
			d='M52.453 51.5252C50.8566 52.7793 48.8859 52.3661 48.0384 50.5984C47.1872 48.8229 47.7817 46.3284 49.3802 45.0323C49.8697 44.635 50.3971 44.3988 50.9187 44.3098C52.109 44.1071 53.2621 44.6939 53.8508 45.9544C54.1293 46.5509 54.2476 47.223 54.2208 47.9024C54.1713 49.2778 53.53 50.6781 52.453 51.5252Z'
			fill='#83AB44'
		/>
		<path
			d='M74.3104 50.3387C75.4709 49.1361 76.4293 47.6792 77.1286 46.0369C78.5496 42.7018 78.6806 39.1319 77.4638 36.2636C75.3273 31.2272 69.7248 30.17 65.1032 33.8951C63.2467 35.393 61.7871 37.4458 60.8826 39.8217C59.6151 43.1387 59.6167 46.5839 60.8597 49.2946C61.0662 49.7449 61.3013 50.163 61.5625 50.5434C62.658 52.1488 64.2026 53.152 65.931 53.5034C68.0769 53.9407 70.5245 53.3763 72.7794 51.6932C73.3199 51.2888 73.8341 50.8357 74.3104 50.3387ZM72.6448 50.9796C69.2589 53.5145 65.3615 53.2716 62.9518 50.7176C62.402 50.1364 61.9262 49.4318 61.551 48.6109C60.3903 46.0711 60.3813 42.879 61.5473 39.838C62.3453 37.7525 63.6253 35.9549 65.2505 34.6481C69.5062 31.227 74.6986 32.2781 76.7101 37.0017C77.8481 39.6741 77.7456 42.9665 76.4512 46.0145C75.703 47.783 74.6074 49.309 73.2688 50.475C73.066 50.6505 72.8575 50.8202 72.6448 50.9796Z'
			fill='#83AB44'
		/>
		<path
			d='M72.0721 49.8869C71.6126 50.2286 71.1407 50.5082 70.6659 50.7252C69.0244 51.4816 67.3237 51.5107 65.8704 50.8851C64.5734 50.3293 63.4656 49.2506 62.7597 47.6975C61.023 43.8764 62.3732 38.5405 65.8468 35.7889C69.3814 32.9862 73.7005 33.9717 75.4161 37.9759C77.1137 41.9381 75.5855 47.2698 72.0721 49.8869Z'
			fill='#83AB44'
		/>
		<path
			d='M70.6646 50.7314C69.0232 51.4878 67.3225 51.517 65.8691 50.8913C67.3982 50.921 69.0021 50.866 70.6646 50.7314Z'
			fill='#679733'
		/>
		<path
			d='M52.453 51.5328C50.8566 52.7869 48.8859 52.3737 48.0384 50.606C47.1872 48.8306 47.7817 46.336 49.3802 45.0399C49.8697 44.6426 50.3971 44.4064 50.9187 44.3174C51.7382 45.7853 52.855 46.9723 54.2208 47.91C54.1713 49.2854 53.53 50.6857 52.453 51.5328Z'
			fill='#679733'
		/>
		<path
			d='M72.7775 51.6952C70.5226 53.3784 68.0749 53.9428 65.9291 53.5055C64.2007 53.1541 62.656 52.1509 61.5605 50.5455C62.0126 50.614 62.4764 50.6714 62.9498 50.7197C65.3595 53.2737 69.2569 53.5166 72.6429 50.9817C72.8556 50.8222 73.0641 50.6526 73.2668 50.4771C73.6099 50.4334 73.96 50.3891 74.3085 50.3408C73.8321 50.8378 73.318 51.2909 72.7775 51.6952Z'
			fill='#679733'
		/>
		<path
			d='M81.437 54.0448L67.5259 58.8008L64.5678 50.8396L56.9004 30.1959L58.6731 29.6625L70.0473 26.2319L71.8902 25.6768L79.8707 49.3916L81.437 54.0448Z'
			fill='#BF7D5A'
		/>
		<path
			d='M81.4375 54.0408L67.5265 58.7969L64.5684 50.8356C69.0921 51.0731 74.3496 50.5022 79.8713 49.3877L81.4375 54.0408Z'
			fill='#AA6256'
		/>
		<path
			d='M79.7021 54.6388L69.1981 58.2295L66.495 50.8925L58.6738 29.662L70.048 26.2314L78.0376 49.7408L79.7021 54.6388Z'
			fill='#FFDE9B'
		/>
		<path
			d='M79.7005 54.6352L69.1973 58.2279L66.4941 50.891C70.0323 50.9064 73.9464 50.4839 78.0368 49.7393L79.7005 54.6352Z'
			fill='#FFD475'
		/>
		<path
			d='M81.4363 54.0439L80.1345 57.8495L66.832 62.3977L67.5252 58.8L81.4363 54.0439Z'
			fill='#8A4852'
		/>
		<path
			d='M69.1968 58.2304L68.5273 61.8194L78.6502 58.3583L79.6999 54.6377L69.1968 58.2304Z'
			fill='#F3A250'
		/>
	</svg>
);
